import { useEffect, useState } from 'react';
import { useSelector } from 'react-redux';
import { useLocation } from 'react-router-dom';

import { getUsername } from '../../util/dataExtractors';
import {
  BUYING,
  SELLING,
  getSideForPath,
  getStoredSide,
  onSideChange,
  storeSide,
} from './dashboardNav';

/** Paths of the signed-in user's own shop page, which belongs to the Selling side. */
export const useOwnStorePaths = () => {
  const currentUser = useSelector(state => state.user.currentUser);
  const username = getUsername(currentUser);
  const userId = currentUser?.id?.uuid;
  return [username ? `/u/${username}` : null, userId ? `/user/${userId}` : null].filter(Boolean);
};

/**
 * The dashboard side being shown, and a setter. A page that belongs to one side decides it;
 * otherwise it's the side last chosen on this device, or Selling for people with listings.
 */
export const useDashboardSide = () => {
  const { pathname } = useLocation();
  const ownStorePaths = useOwnStorePaths();
  const hasListings = useSelector(state => state.user.currentUserHasListings);
  // Read after mounting, so the server render and the first browser render match
  const [chosenSide, setChosenSide] = useState(null);

  useEffect(() => {
    setChosenSide(getStoredSide());
    return onSideChange(setChosenSide);
  }, []);

  const pathSide = getSideForPath(pathname, ownStorePaths);
  useEffect(() => {
    if (pathSide && pathSide !== getStoredSide()) {
      storeSide(pathSide);
    }
  }, [pathSide]);

  const side = pathSide || chosenSide || (hasListings ? SELLING : BUYING);
  return [side, storeSide];
};
